import React from 'react';
import Bootstrap from 'src/components/pages/_bootstrap/bootstrap';
import { AdditionalAttributePageSkeleton, AdditionalAttributesPageSkeleton } from 'src/components/pages/additionalAttributes/additionalAttributesSkeleton';
import { AICreativeToolsCustomAppsPageSkeleton } from 'src/components/pages/aiCreativeToolsCustomApps/aiCreativeToolsCustomAppsSkeleton';
import { AIProductStagingRulePageSkeleton, AIProductStagingRulesPageSkeleton } from 'src/components/pages/aiProductStagingRules/aiProductStagingRulesSkeleton';
import { AiStudioPageSkeleton } from 'src/components/pages/aiStudio/aiStudioSkeleton';
import { AIUsageHistoryPageSkeleton } from 'src/components/pages/aiUsageHistory/aiUsageHistorySkeleton';
import { AIVirtualModelRulePageSkeleton, AIVirtualModelRulesPageSkeleton } from 'src/components/pages/aiVirtualModelRules/aiVirtualModelRulesSkeleton';
import { FillBackgroundPageSkeleton, FillBackgroundRulePageSkeleton } from 'src/components/pages/areaBackgroundMenu/areaBackgroundSkeleton';
import { BackgroundColorRulePageSkeleton, BackgroundColorRulesPageSkeleton } from 'src/components/pages/backgroundColor/backgroundColorSkeleton';
import { BackgroundRecolorRedirect } from 'src/components/pages/backgroundColor/redirect';
import {
    BulkImportExportWizardPageSkeleton,
    BulkImportHistoryPageSkeleton,
    BulkImportPageSkeleton,
    BulkImportSetupPageSkeleton,
    BulkImportTaskDetailPageSkeleton,
    BulkImportWizardPageSkeleton
} from 'src/components/pages/bulkImport/bulkImportSkeleton';
import { BulkProductsListPageSkeleton } from 'src/components/pages/bulkProductsList/bulkProductsListSkeleton';
import { BulkVariationPageSkeleton } from 'src/components/pages/bulkVariation/bulkVariationSkeleton';
import { UserCheckoutPageSkeleton } from 'src/components/pages/checkout/checkoutSkeleton';
import { ChoosePlanPageSkeleton, SubscriptionStartPageSkeleton } from 'src/components/pages/choosePlan/choosePlanSkeleton';
import { ColorSystemPageSkeleton, ColorSystemPalettePageSkeleton } from 'src/components/pages/colorSystem/colorSystemSkeleton';
import { DraftConfigurationsPageSkeleton } from 'src/components/pages/compositionDrafts/customersConfigurationsSkeleton';
import { ConnectorRulePageSkeleton, ConnectorRulesPageSkeleton } from 'src/components/pages/connectors/connectorRules/connectorRulesSkeleton';
import { DraftDesignsPageSkeleton } from 'src/components/pages/customersDesigns/customersDesignsSkeleton';
import { DamPageSkeleton } from 'src/components/pages/dam/damSkeleton';
import { DamProjectsDetailPageSkeleton, DamProjectsListingPageSkeleton } from 'src/components/pages/dam/projects/projectsSkeleton';
import { DamAssetLibraryDetailPageSkeleton, DamAssetLibraryListingPageSkeleton } from 'src/components/pages/dam/assetLibrary/assetLibrarySkeleton';
import { DamAnalyticsPageSkeleton } from 'src/components/pages/dam/analytics/analyticsSkeleton';
import { DamOptimizePageSkeleton } from 'src/components/pages/dam/optimize/optimizeSkeleton';
import { DashboardPageSkeleton } from 'src/components/pages/dashboard/dashboardSkeleton';
import { DashboardAnalyticsPageSkeleton } from 'src/components/pages/dashboardAnalytics/dashboardAnalyticsSkeleton';
import { DesignToTemplatePageSkeleton } from 'src/components/pages/designToTemplate/designToTemplateSkeleton';
import { ECommerceConnectionsPageSkeleton, ECommerceSetupPageSkeleton } from 'src/components/pages/ecommerceConnection/ecommerceConnectionSkeleton';
import { ECommerceRedirect } from 'src/components/pages/ecommerceConnection/redirect';
import { EcommerceStartPageSkeleton } from 'src/components/pages/ecommerceStart/ecommerceStartSkeleton';
import { GeneralSettingsPageSkeleton } from 'src/components/pages/generalSettings/generalSettingsSkeleton';
import { GeneralSettingsConfiguratorPageSkeleton } from 'src/components/pages/generalSettingsConfigurator/generalSettingsConfiguratorSkeleton';
import { ImagesPageSkeleton } from 'src/components/pages/images/imagesSkeleton';
import {
    ProviderConfigurationPageSkeleton,
    ProviderDetailPageSkeleton
} from 'src/components/pages/integrationSettings/providerConfiguration/providerConfigurationSkeleton';
import { InvoicesPageSkeleton } from 'src/components/pages/invoices/invoicesSkeleton';
import { LandingPageSkeleton } from 'src/components/pages/landings/landingSkeleton';
import {
    AIDesignGenerationRedirect,
    AIImageGenerationRedirect,
    AIProductStagingRuleLegacyRedirect,
    AIProductStagingRuleRedirect,
    AIProductStagingRulesLegacyRedirect,
    AIProductStagingRulesRedirect,
    AIRedirect,
    AIStudioLegacyRedirect,
    AIVirtualModelRuleLegacyRedirect,
    AIVirtualModelRuleRedirect,
    AIVirtualModelRulesLegacyRedirect,
    AIVirtualModelRulesRedirect,
    AreaBackgroundRedirect,
    AreaBackgroundRuleRedirect,
    AreaBackgroundRulesRedirect,
    BulkVariationProductListRedirect,
    BulkVariationRedirect,
    BulkVariationSettingsListRedirect,
    BulkVariationSettingsRedirect,
    CollageLayoutGridRuleRedirect,
    CollageLayoutGridRulesRedirect,
    CollageLayoutRedirect,
    CollageLayoutTabRedirect,
    CustomizerMessagesRedirect,
    DamLegacyRedirect,
    DraftConfigurationsRedirect,
    DraftDesignsRedirect,
    ImagesRedirect,
    ImagesSubpageRedirect,
    IntegrationsRedirect,
    LegacyPlatformSettingsRedirect,
    MoqMenuRedirect,
    MoqRulesRedirect,
    PlacementProductSelectionRedirect,
    PlacementsRedirect,
    Preview3DCamerasRedirect,
    Preview3DProductsRedirect,
    Preview3DRedirect,
    PricingAdvancedEmbeddedRedirect,
    PricingAdvancedRedirect,
    PricingRulesEmbeddedRedirect,
    PricingRulesRedirect,
    PricingsAdvancedRedirect,
    ProfanityFilterRulesRedirect,
    SalesChannelIntegrationPlatformRedirect,
    SalesChannelIntegrationRedirect,
    TemplateTaskDetailRedirect,
    TemplateTasksRedirect,
    TestModeRedirect,
    TranslationsContainerRedirect
} from 'src/components/pages/legacyRedirects';
import { MoqPageSkeleton, MoqRulePageSkeleton } from 'src/components/pages/moq/moqSkeleton';
import { UserPageSkeleton } from 'src/components/pages/myAccount/myAccountSkeleton';
import { OfflineOrderPageSkeleton } from 'src/components/pages/offlineOrder/offlineOrderSkeleton';
import { OrderPageSkeleton } from 'src/components/pages/order/orderSkeleton';
import { OrderDesignEditorPageSkeleton } from 'src/components/pages/orderDesignEditor/orderDesignEditorSkeleton';
import { MarketplaceOrderPageSkeleton } from 'src/components/pages/orders/marketplace/marketplaceOrder/marketplaceOrderSkeleton';
import { OrdersPageSkeleton } from 'src/components/pages/orders/ordersSkeleton';
import { OnboardingPageSkeleton } from 'src/components/pages/onboarding/onboardingSkeleton';
import { OrdersSettingsPageSkeleton } from 'src/components/pages/ordersSettings/ordersSettingsSkeleton';
import { PdfPreviewSettingsPageSkeleton } from 'src/components/pages/pdfPreviewSettings/pdfPreviewSettingsSkeleton';
import { AdvancedPrintFileProductsPageSkeleton, PlacementProductPageSkeleton } from 'src/components/pages/placementProduct/placementProductSkeleton';
import { PlacementPageSkeleton } from 'src/components/pages/placements/placementSkeleton';
import { PlatformIntegrationSettingsPageSkeleton } from 'src/components/pages/platformIntegrationSettings/platformIntegrationSettingsSkeleton';
import { PlatformSelectionPageSkeleton } from 'src/components/pages/platformSelection/platformSelectionSkeleton';
import {
    PresetConfigurationsProductPickedPageSkeleton,
    PresetConfigurationsProductsPageSkeleton
} from 'src/components/pages/presetConfigurations/presetConfigurationsSkeleton';
import { CameraConfigurationPageSkeleton, Preview3DPageSkeleton } from 'src/components/pages/preview3D/preview3DSkeleton';
import ProofingHub, { ProofingHubRouteSkeleton } from 'src/components/pages/proofingHub';
import { Preview3DProductsPageSkeleton } from 'src/components/pages/preview3DProducts/preview3DProductsSkeleton';
import { PricingRuleEmbeddedPageSkeleton, PricingRulePageSkeleton, PricingRulesPageSkeleton } from 'src/components/pages/pricingsAdvanced/pricingSkeleton';
import { PricingsBasePageSkeleton } from 'src/components/pages/pricingsBase/pricingsBaseSkeleton';
import { PricingsTypePageSkeleton } from 'src/components/pages/pricingsType/pricingsTypeSkeleton';
import { PrintTypePageSkeleton } from 'src/components/pages/printType/printTypeSkeleton';
import { PrintTypesPageSkeleton } from 'src/components/pages/printTypes/printTypesSkeleton';
import { ProductConfigurationSkeleton } from 'src/components/pages/productConfiguration/productConfigurationSkeleton';
import {
    ProductItemTemplatesPageSkeleton,
    ProductTemplatesPageSkeleton,
    TemplateTaskDetailPageSkeleton
} from 'src/components/pages/productTemplates/productTemplatesSkeleton';
import { ProductDuplicationTaskDetailPageSkeleton, ProductsPageSkeleton } from 'src/components/pages/products/productsSkeleton';
import { ProofDetailsPageSkeleton, ProofListPageSkeleton, ProofWorkflowDefinitionsPageSkeleton } from 'src/components/pages/proofing/proofingSkeleton';
import {
    ProfanityFilterAnalyticsPageSkeleton,
    ProfanityFilterMenuPageSkeleton,
    ProfanityFilterRulePageSkeleton,
    ProfanityFilterRulesPageSkeleton
} from 'src/components/pages/profanityFilter/profanityFilterSkeleton';
import { ReportViewsTryOnPageSkeleton } from 'src/components/pages/reportViewsTryOn/reportViewsTryOnSkeleton';
import {
    SalesChannelSwitchTaskDetailPageSkeleton,
    SalesChannelSwitchTasksPageSkeleton,
    SalesChannelsPageSkeleton
} from 'src/components/pages/salesChannels/salesChannelsSkeleton';
import {
    ColorPaletteSettingsPageSkeleton,
    PaletteColorsPageSkeleton,
    PantoneLibraryPageSkeleton,
    SellerPantoneColorsPageSkeleton
} from 'src/components/pages/settings/colorPaletteSettings/colorPaletteSettingsSkeleton';
import PaletteColorsPage from 'src/components/pages/settings/colorPaletteSettings/paletteColorsPage';
import PantoneLibraryPage from 'src/components/pages/settings/colorPaletteSettings/pantoneLibrary/pantoneLibraryPage';
import { ExtensionFieldPageSkeleton } from 'src/components/pages/settings/extensionFieldPage/extensionFieldPageSkeleton';
import { ExtensionFieldsPageSkeleton } from 'src/components/pages/settings/extensionFields/extensionFieldsSkeleton';
import { SettingsFormPageSkeleton, SettingsTablePageSkeleton } from 'src/components/pages/settings/settingsSkeleton';
import { TranslationsPageSkeleton } from 'src/components/pages/settings/translations/translationsSkeleton';
import {
    StandaloneSiteCollectionPageSkeleton,
    StandaloneSiteDetailPageSkeleton,
    StandaloneSiteThemeSettingsPageSkeleton
} from 'src/components/pages/settings/standaloneSites/standaloneSitesSkeleton';
import { ShapesPageSkeleton } from 'src/components/pages/shapes/shapesSkeleton';
import { SupportPageSkeleton } from 'src/components/pages/support/supportSkeleton';
import { TestPageSkeleton } from 'src/components/pages/testPage/testPageSkeleton';
import { AIImageGenerationPageSkeleton } from 'src/components/pages/tools/aiImageGeneration/aiImageGenerationSkeleton';
import { CollageLayoutPageSkeleton, CollageLayoutRulePageSkeleton } from 'src/components/pages/tools/collageLayout/collageLayoutSkeleton';
import { CsvImporterPageSkeleton } from 'src/components/pages/tools/csvImporter/csvImporterSkeleton';
import { DesignWithAiPageSkeleton } from 'src/components/pages/tools/designWithAi/designWithAiSkeleton';
import { FontsPageSkeleton } from 'src/components/pages/tools/fonts/fontsSkeleton';
import { GetAQuotePageSkeleton, QuotePageSkeleton, QuoteRulePageSkeleton } from 'src/components/pages/tools/getAQuote/getAQuoteSkeleton';
import { ToolsPageSkeleton } from 'src/components/pages/tools/toolsSkeleton';
import { UserInterfaceSettingsPageSkeleton } from 'src/components/pages/userInterfaceSettings/userInterfaceSettingsSkeleton';
import { VirtualTryOnPageSkeleton } from 'src/components/pages/virtualTryOn/virtualTryOnSkeleton';
import { backofficeUrl } from './helpers';

const Dashboard = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "dashboard" */ 'src/components/pages/dashboard'));
const Onboarding = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "onboarding" */ 'src/components/pages/onboarding'));
const PlatformSelection = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "platformSelection" */ 'src/components/pages/platformSelection'));

const EcommerceStart = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "ecommerceStart" */ 'src/components/pages/ecommerceStart'));
const ChoosePlan = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "choosePlan" */ 'src/components/pages/choosePlan'));
const ChoosePlanV2 = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "choosePlan" */ 'src/components/pages/choosePlan/choosePlanV2'));
const SetDefaultPlan = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "setDefaultPlan" */ 'src/components/pages/choosePlan/setDefaultPlan')
);
const StartsShopifySubscription = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "startsShopifySubscription" */ 'src/components/pages/choosePlan/startsShopifySubscription')
);
const ProductConfiguration = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "productConfiguration" */ 'src/components/pages/productConfiguration')
);
const TestPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "testPage" */ 'src/components/pages/testPage'));
const OfflineOrder = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "offlineOrder" */ 'src/components/pages/offlineOrder'));

const PricingsType = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "pricingsType" */ 'src/components/pages/pricingsType'));
const PricingsAdvanced = React.lazy(() => import(/* webpackChunkName: "pricingsAdvanced", webpackPrefetch: true */ 'src/components/pages/pricingsAdvanced'));
const PricingsBase = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "pricingsBase" */ 'src/components/pages/pricingsBase'));
const Pricing = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "pricings" */ 'src/components/pages/pricingsAdvanced/pricing'));

const PrintTypePage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "printType" */ 'src/components/pages/printType'));
const PrintTypes = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "printTypes" */ 'src/components/pages/printTypes'));

const AdditionalAttributes = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "additionalAttributes" */ 'src/components/pages/additionalAttributes')
);
const AdditionalAttributePage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "additionalAttribute" */ 'src/components/pages/additionalAttributes/additionalAttribute')
);

const Orders = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "orders" */ 'src/components/pages/orders'));
const OrdersSettings = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "ordersSettings" */ 'src/components/pages/ordersSettings'));
const OrderDesignEditor = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "order" */ 'src/components/pages/orderDesignEditor'));
const ProofListPage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "proofList" */ 'src/components/pages/proofing/proofList/ProofListPage')
);
const ProofDetailsPage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "proofDetails" */ 'src/components/pages/proofing/proofDetails/ProofDetailsPage')
);
const ProofWorkflowDefinitionsPage = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "proofWorkflowDefinitions" */ 'src/components/pages/proofing/workflowDefinitions/ProofWorkflowDefinitionsPage'
        )
);

const ShopifyOrderDetailContent = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "shopifyOrderDetailContent" */ 'src/components/pages/orders/shopifyOrderDetailContent')
);
const MarketplaceOrderPage = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "marketplaceOrderPage" */ 'src/components/pages/orders/marketplace/marketplaceOrder/marketplaceOrderPage'
        )
);
const OrderPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "orderPage" */ 'src/components/pages/order/orderPage'));

const MarketplaceOrder = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "marketplaceOrder" */ 'src/components/pages/orders/marketplace/marketplaceOrder/marketplaceOrderPage'
        )
);

const BulkProductsList = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "bulkProductsList" */ 'src/components/pages/bulkProductsList'));
const BulkVariationPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "bulkVariation" */ 'src/components/pages/bulkVariation'));

const UserCheckout = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "checkout" */ 'src/components/pages/checkout'));

const UserPage = React.lazy(() => import('src/components/pages/myAccount'));

const Support = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "support" */ 'src/components/pages/support/support'));

const ShopifyNeedUpdateScope = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "ShopifyNeedUpdateScope" */ 'src/components/pages/settings/shopifyNeedUpdateScope')
);

const PlatformIntegrationSettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "platformIntegrationSettings" */ 'src/components/pages/platformIntegrationSettings')
);
const GeneralSettings = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "genericSettings" */ 'src/components/pages/generalSettings'));
const GeneralSettingsConfigurator = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "generalSettingsConfigurator" */ 'src/components/pages/generalSettingsConfigurator')
);

const ExtensionFieldsSettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "extensionFields" */ 'src/components/pages/settings/extensionFields')
);
const ExtensionFieldPage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "extensionFieldPage" */ 'src/components/pages/settings/extensionFieldPage')
);

const Shapes = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "shapes" */ 'src/components/pages/shapes'));

const Images = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "images" */ 'src/components/pages/images'));

const UserInterfaceNew = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "userInterfaceNew" */ 'src/components/pages/userInterfaceSettings/userInterfaceSettingsEditor')
);
const UserInterfaceSettingsEditor = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "userInterfaceSettingsEditor" */ 'src/components/pages/userInterfaceSettings/userInterfaceSettingsEditor'
        )
);
const UserInterfaceSettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "userInterfaceSettings" */ 'src/components/pages/userInterfaceSettings')
);
const UserInterfaceSettingsConfigurator = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "userInterfaceSettingsConfigurator" */ 'src/components/pages/userInterfaceSettingsConfigurator')
);
const CustomizerThemeItems = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "customizerThemeItems" */ 'src/components/pages/settings/customizerThemeItems')
);
const CustomizerThemeItemPage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "customizerThemeItem" */ 'src/components/pages/settings/customizerThemeItem')
);

const Translations = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "translations" */ 'src/components/pages/settings/translations'));

const WebHooksSettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "webHooksSettings" */ 'src/components/pages/integrationSettings/webHooksSettings')
);

const CliLogin = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "cliLogin" */ 'src/components/pages/cliLogin'));

const Fonts = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "fonts" */ 'src/components/pages/tools/fonts'));
const CollageLayout = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "collageLayout" */ 'src/components/pages/tools/collageLayout'));
const GridRule = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "gridRule" */ 'src/components/pages/tools/collageLayout/gridRules/gridRule')
);
const GetAQuote = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "getAQuote" */ 'src/components/pages/tools/getAQuote'));
const QuoteRule = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "quoteRule" */ 'src/components/pages/tools/getAQuote/rules/quoteRule'));
const Quote = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "quote" */ 'src/components/pages/tools/getAQuote/quotes/quote'));

const SettingsMessages = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "printTypes" */ 'src/components/pages/settings/customizerMessages')
);
const CustomizerMessageByEvent = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "customizerMessageByEvent" */ 'src/components/pages/settings/customizerMessageByEvent')
);

const DesignToTemplate = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "designToTemplate" */ 'src/components/pages/designToTemplate'));

const ProductTemplates = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "template-product-selection" */ 'src/components/pages/productTemplates')
);
const ProductItemTemplates = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "template-product-selection-templates" */ 'src/components/pages/productTemplates/productItemTemplates'
        )
);
const StandaloneTemplateEditor = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "standalone-template-editor" */ 'src/components/pages/productTemplates/standaloneTemplateEditor')
);
const TemplateTaskDetail = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "template-task-detail" */ 'src/components/pages/productTemplates/templateTaskDetail')
);

const ColorSystem = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "designToTemplate" */ 'src/components/pages/colorSystem'));
const ColorSystemPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "designToTemplate" */ 'src/components/pages/colorSystemPage'));

// Landings
const CustomizerLanding = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "customizerLanding" */ 'src/components/pages/landings/customizerLanding')
);
const ConfiguratorLanding = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "configuratorLanding" */ 'src/components/pages/landings/configuratorLanding')
);
const ViewerLanding = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "viewerLanding" */ 'src/components/pages/landings/viewerLanding'));
const PdfPreviewSettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "pdfPreviewSettings" */ 'src/components/pages/pdfPreviewSettings')
);
const PdfSummarySettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "pdfSummarySettings" */ 'src/components/pages/pdfSummarySettings')
);
const QuoteSummarySettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "pdfSummarySettings" */ 'src/components/pages/quoteSummarySettings/quoteSummarySettings')
);

const ColorPaletteSettings = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "ColorPaletteSettings" */ 'src/components/pages/settings/colorPaletteSettings/index')
);
// const PaletteColorsPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "paletteColors" */ 'src/components/pages/settings/PaletteColors/index'));

// const PantoneLibraryPage = React.lazy(
// 	() => import(/* webpackPrefetch: true, webpackChunkName: "pantoneLibrary" */ 'src/components/pages/settings/colorLibrarySettings/pantoneLibrary/pantoneLibraryPage')
// );

const StandaloneSiteDetail = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "standaloneSiteDetail" */ 'src/components/pages/settings/standaloneSites/standaloneSiteDetail')
);
const StandaloneSiteCollectionDetail = React.lazy(
    () =>
        import(/* webpackPrefetch: true, webpackChunkName: "standaloneSiteCollectionDetail" */ 'src/components/pages/settings/standaloneSites/collectionDetail')
);
const ThemeSettingsEditor = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "themeSettingsEditor" */ 'src/components/pages/settings/standaloneSites/themeSettings')
);

const SalesChannels = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "salesChannels" */ 'src/components/pages/salesChannels'));
const SalesChannelSwitchTasks = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "salesChannelSwitchTasks" */ 'src/components/pages/salesChannels/switch/salesChannelSwitchTasks')
);
const SalesChannelSwitchTaskDetail = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "salesChannelSwitchTaskDetail" */ 'src/components/pages/salesChannels/switch/salesChannelSwitchTaskDetail'
        )
);

const Products = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "products" */ 'src/components/pages/products'));
const ProductDuplicationTaskDetail = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "productDuplicationTaskDetail" */ 'src/components/pages/products/productDuplicationTaskDetail')
);
const CategorizeAiGeneration = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "categorizeAiGeneration" */ 'src/components/pages/products/categorizeAiGeneration')
);

const MenuCategoryPage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "menuCategory" */ 'src/components/pages/menuCategory/menuCategory')
);

const AI = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "ai" */ 'src/components/pages/ai'));

const ProfanityFilterMenu = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "profanityFilterMenu" */ 'src/components/pages/profanityFilter')
);
const ProfanityFilterRules = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "profanityFilterRules" */ 'src/components/pages/profanityFilter/profanityFilterRules')
);
const ProfanityFilterRule = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "profanityFilterRule" */ 'src/components/pages/profanityFilter/profanityFilterRule')
);
const PorfanityFilterAnalytics = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "profanityFilterAnalytics" */ 'src/components/pages/profanityFilter/profanityFilterAnalytics')
);

const MoqRule = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "moqRule" */ 'src/components/pages/moq/moq'));

const DamProjects = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "damProjects" */ 'src/components/pages/dam/projects'));
const DamProjectDetail = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "damProjects" */ 'src/components/pages/dam/projects/detail'));
const DamAssetLibrary = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "damAssetLibrary" */ 'src/components/pages/dam/assetLibrary'));
const DamAssetLibraryDetail = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "damAssetLibrary" */ 'src/components/pages/dam/assetLibrary/detail')
);
const DamAnalytics = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "damAnalytics" */ 'src/components/pages/dam/analytics'));
const DamOptimize = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "damAssetLibrary" */ 'src/components/pages/dam/optimize'));
const DamRelayer = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "dam" */ 'src/components/pages/damRelayer'));

const DashboardAnalytics = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "dasboardAnalytics" */ 'src/components/pages/dashboardAnalytics')
);

const ReportViewsTryOn = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "reportViewsTryOn" */ 'src/components/pages/reportViewsTryOn'));
const ProviderConfiguration = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "providerConfiguration" */ 'src/components/pages/integrationSettings/providerConfiguration')
);
const PrintfulProviderPage = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "providerConfiguration" */ 'src/components/pages/integrationSettings/providerConfiguration/printfulPage'
        )
);
const CustomCatProviderPage = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "providerConfiguration" */ 'src/components/pages/integrationSettings/providerConfiguration/customCatPage'
        )
);
const PrinteersProviderPage = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "providerConfiguration" */ 'src/components/pages/integrationSettings/providerConfiguration/printeersPage'
        )
);

const PlacementProduct = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "placement-product" */ 'src/components/pages/placementProduct'));
const Placements = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "placements" */ 'src/components/pages/placements'));
const Placement = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "placement" */ 'src/components/pages/placement'));

const InvoicesPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "invoices-page" */ 'src/components/pages/invoices'));

const Preview3DProducts = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "preview3DProducts" */ 'src/components/pages/preview3DProducts/preview3DProducts')
);
const Preview3DPage = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "preview3D" */ 'src/components/pages/preview3D'));
const CameraConfiguration = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "cameraConfiguration" */ 'src/components/pages/preview3D/cameraConfiguration')
);
const VirtualTryOn = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName:"virtualTryOn" */ 'src/components/pages/virtualTryOn'));

// Preset configurations
const PresetConfigurationsProducts = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "presetConfigurationsProducts" */ 'src/components/pages/presetConfigurations/products/presetConfigurationsProducts'
        )
);
const PresetConfigurationsProductPicked = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "presetConfigurationsProductPicked" */ 'src/components/pages/presetConfigurations/products/presetConfigurationsProductPicked'
        )
);

//Connectors
const ConnectorRules = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "connectorRules" */ 'src/components/pages/connectors/connectorRules/connectorRules')
);
const ConnectorRule = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "connectorRules" */ 'src/components/pages/connectors/connectorRules/connectorRule')
);
const EmptyPage = () => null;

const PermissionsLogin = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "permissionsLogin" */ 'src/components/pages/permissions/permissionsLogin')
);
const PermissionsLoginSellerSelection = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "permissionsLoginSellerSelection" */ 'src/components/pages/permissions/permissionsLoginSellerSelection'
        )
);
const PermissionsLoginSellerSelectionCompleted = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "permissionsLoginSellerSelectionCompleted" */ 'src/components/pages/permissions/permissionsLoginSellerSelectionCompleted'
        )
);

const CsvImporter = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "csvImporter" */ 'src/components/pages/tools/csvImporter'));
const BulkImportLanding = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "bulkImport" */ 'src/components/pages/bulkImport/landing'));
const BulkImportHistory = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "bulkImportHistory" */ 'src/components/pages/bulkImport/bulkImportHistory')
);
const BulkImportTaskDetail = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "bulkImportTaskDetail" */ 'src/components/pages/bulkImport/taskDetail')
);
const BulkImportWizard = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "bulkImportWizard" */ 'src/components/pages/bulkImport/wizard'));
const BulkImportSetup = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "bulkImportSetup" */ 'src/components/pages/bulkImport/setup'));
const BulkImportExportWizard = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "bulkImportExportWizard" */ 'src/components/pages/bulkImport/export')
);
const AIImageGeneration = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "aiImageGeneration" */ 'src/components/pages/tools/aiImageGeneration')
);
const DesignWithAi = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "designWithAi" */ 'src/components/pages/tools/designWithAi'));
const AiStudio = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "aiStudio" */ 'src/components/pages/aiStudio'));
const AICreativeToolsCustomApps = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "aiCreativeToolsCustomApps" */ 'src/components/pages/aiCreativeToolsCustomApps')
);
const AIProductStagingRules = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "aiProductStagingRules" */ 'src/components/pages/aiProductStagingRules')
);
const AIProductStagingRule = React.lazy(() =>
    import(/* webpackPrefetch: true, webpackChunkName: "aiProductStagingRule" */ 'src/components/pages/aiProductStagingRules').then((module) => ({
        default: module.AIProductStagingRulePage
    }))
);
const AIVirtualModelRules = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "aiVirtualModelRules" */ 'src/components/pages/aiVirtualModelRules')
);
const AIUsageHistory = React.lazy(() => import(/* webpackChunkName: "aiUsageHistory" */ 'src/components/pages/aiUsageHistory/aiUsageHistory'));
const AIVirtualModelRule = React.lazy(() =>
    import(/* webpackPrefetch: true, webpackChunkName: "aiVirtualModelRule" */ 'src/components/pages/aiVirtualModelRules').then((module) => ({
        default: module.AIVirtualModelRulePage
    }))
);
const CustomersDesigns = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "customersDesigns" */ 'src/components/pages/customersDesigns'));
const CustomerConfigurations = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "customerConfigurations" */ 'src/components/pages/compositionDrafts')
);
const AreaBackgroundRulesOrImages = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "rulesOrImages" */ 'src/components/pages/areaBackgroundMenu/rulesOrImages')
);
const AreaBackgroundRule = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "areaBackgroundRule" */ 'src/components/pages/areaBackgroundMenu/areaBackgroundRule')
);

const SubscriptionChecker = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "subscriptionChecker" */ 'src/components/pages/subscriptions/checker')
);
const SubscriptionCheckForCancelling = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "subscriptionCheckForCancelling" */ 'src/components/pages/subscriptions/checkForCancelling')
);
const SubscriptionRequestTrialExtension = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "subscriptionRequestTrialExtension" */ 'src/components/pages/subscriptions/requestTrialExtension')
);
const SubscriptionCheckForExisting = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "subscriptionCheckForExisting" */ 'src/components/pages/subscriptions/checkForExisting')
);
const SubscriptionCheckForActivation = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "subscriptionCheckForActivation" */ 'src/components/pages/subscriptions/checkForActivation')
);

const ECommerceConnections = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "eCommerceConnections" */ 'src/components/pages/ecommerceConnection/eCommerceConnection')
);
const PantoneColors = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "pantoneColors" */ 'src/components/pages/pantoneColors'));

// Temporary until we migrate all the backoffice
const isOldProductView = Boolean(document.getElementById('product-tab-content'));

const BackgroundColorRules = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "backgroundRecolorRules" */ 'src/components/pages/backgroundColor/backgroundColorRules')
);
const BackgroundColorRule = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "backgroundRecolorRule" */ 'src/components/pages/backgroundColor/backgroundColorRule')
);

const UserSyncChecker = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "userSyncChecker" */ 'src/components/pages/userSyncChecker/userSyncChecker')
);

const PrintfulIntegration = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "printfulActivation" */ 'src/components/pages/integrationSettings/providerConfiguration/providers/printfulIntegration'
        )
);

const AmazonChoiceMarketplacePage = React.lazy(
    () => import(/* webpackPrefetch: true, webpackChunkName: "amazonChoiceMarketplacePage" */ 'src/components/pages/amazonChoiceMarketplace')
);

const RedirectForUpgradePlanForShopify = React.lazy(
    () =>
        import(
            /* webpackPrefetch: true, webpackChunkName: "RedirectForUpgradePlanForShopifyProps" */ 'src/components/pages/choosePlan/redirectForUpgradePlanForShopify'
        )
);

const RedirectPartner = React.lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "RedirectPartner" */ 'src/components/pages/partnerProgram'));

type Route = {
    url: string;
    component: React.ComponentType;
    isHeaderHidden?: boolean;
    isMenuHidden?: boolean;
    noGutters?: boolean;
    isSubscriptionRequested?: boolean;
    forceTools?: boolean;
    isGuestAllowed?: boolean;
    refreshCredits?: boolean;
    skeleton?: React.ComponentType;
};
export type { Route };

const MENU_CATEGORY_ROUTE_KEYS = ['customization-tools', 'commerce-rules', 'sales-channels-and-modules', 'libraries', 'platform-settings'];

const routes: Route[] = [
    { url: backofficeUrl(''), component: Bootstrap },
    { url: backofficeUrl('/'), component: Bootstrap },
    {
        url: backofficeUrl('/onboarding/result'),
        component: Onboarding,
        isHeaderHidden: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: OnboardingPageSkeleton
    },
    {
        url: backofficeUrl('/onboarding/ask-zakeke'),
        component: Onboarding,
        isHeaderHidden: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: OnboardingPageSkeleton
    },
    {
        url: backofficeUrl('/onboarding/solutions'),
        component: Onboarding,
        isHeaderHidden: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: OnboardingPageSkeleton
    },
    {
        url: backofficeUrl('/onboarding'),
        component: Onboarding,
        isHeaderHidden: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: OnboardingPageSkeleton
    },
    { url: backofficeUrl('/dashboard'), component: Dashboard, isSubscriptionRequested: true, refreshCredits: true, skeleton: DashboardPageSkeleton },
    { url: backofficeUrl('/internal/e-commerce'), component: ECommerceConnections, isSubscriptionRequested: true, skeleton: ECommerceConnectionsPageSkeleton },

    { url: backofficeUrl('/e-commerce'), component: ECommerceRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/amazonSelectMarketplace'), component: AmazonChoiceMarketplacePage, skeleton: ECommerceSetupPageSkeleton },
    { url: backofficeUrl('/choose-ecommerce'), component: ECommerceRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/connect-shop'), component: PlatformSelection, isSubscriptionRequested: true, skeleton: PlatformSelectionPageSkeleton },

    {
        url: backofficeUrl('/e-commerce/start'),
        component: EcommerceStart,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: EcommerceStartPageSkeleton
    },
    {
        url: backofficeUrl('/seller/subscription'),
        component: ChoosePlan,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        skeleton: ChoosePlanPageSkeleton
    },
    {
        url: backofficeUrl('/sellersubscriptionstart'),
        component: SetDefaultPlan,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        skeleton: SubscriptionStartPageSkeleton
    },
    {
        url: backofficeUrl('/subscriptionstartshopify'),
        component: StartsShopifySubscription,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        skeleton: SubscriptionStartPageSkeleton
    },

    {
        url: backofficeUrl('/draft-designs'),
        component: CustomersDesigns,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: DraftDesignsPageSkeleton
    },
    {
        url: backofficeUrl('/draft-configurations'),
        component: CustomerConfigurations,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: DraftConfigurationsPageSkeleton
    },
    {
        url: backofficeUrl('/products/duplication-tasks/:taskId'),
        component: ProductDuplicationTaskDetail,
        isSubscriptionRequested: true,
        skeleton: ProductDuplicationTaskDetailPageSkeleton
    },
    {
        url: backofficeUrl('/products/categorize-ai'),
        component: CategorizeAiGeneration,
        isSubscriptionRequested: true
    },
    {
        url: backofficeUrl('/products'),
        component: isOldProductView ? EmptyPage : Products,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProductsPageSkeleton
    },
    {
        url: backofficeUrl('/product/:page?/:subpage?/:subpage2?'),
        component: isOldProductView ? EmptyPage : ProductConfiguration,
        isSubscriptionRequested: true,
        skeleton: ProductConfigurationSkeleton
    },

    { url: backofficeUrl('/test-mode/:productId'), component: TestPage, isSubscriptionRequested: true, skeleton: TestPageSkeleton },
    { url: backofficeUrl('/test-mode/'), component: TestPage, isSubscriptionRequested: true, skeleton: TestPageSkeleton },

    {
        url: backofficeUrl('/3Dpreview-and-AR/products'),
        component: Preview3DProducts,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: Preview3DProductsPageSkeleton
    },
    {
        url: backofficeUrl('/3Dpreview-and-AR/cameras'),
        component: CameraConfiguration,
        isSubscriptionRequested: true,
        skeleton: CameraConfigurationPageSkeleton
    },
    { url: backofficeUrl('/3Dpreview-and-AR/:subpage?'), component: Preview3DPage, isSubscriptionRequested: true, skeleton: Preview3DPageSkeleton },

    // Preset configurations
    {
        url: backofficeUrl('/preset-configurations'),
        component: PresetConfigurationsProducts,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: PresetConfigurationsProductsPageSkeleton
    },
    {
        url: backofficeUrl('/preset-configurations/products'),
        component: PresetConfigurationsProducts,
        isSubscriptionRequested: true,
        skeleton: PresetConfigurationsProductsPageSkeleton
    },
    {
        url: backofficeUrl('/preset-configurations/products/:id'),
        component: PresetConfigurationsProductPicked,
        isSubscriptionRequested: true,
        skeleton: PresetConfigurationsProductPickedPageSkeleton
    },

    { url: backofficeUrl('/pricing-rule/:subpage?'), component: Pricing, isSubscriptionRequested: true, skeleton: PricingRulePageSkeleton },
    {
        url: backofficeUrl('/pricing-rule-embedded/:subpage?'),
        component: Pricing,
        isMenuHidden: true,
        isHeaderHidden: true,
        isSubscriptionRequested: true,
        skeleton: PricingRuleEmbeddedPageSkeleton
    },

    { url: backofficeUrl('/pricings'), component: PricingsType, isSubscriptionRequested: true, refreshCredits: true, skeleton: PricingsTypePageSkeleton },
    { url: backofficeUrl('/pricings-base'), component: PricingsBase, isSubscriptionRequested: true, refreshCredits: true, skeleton: PricingsBasePageSkeleton },
    {
        url: backofficeUrl('/pricings-rules'),
        component: PricingsAdvanced,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: PricingRulesPageSkeleton
    },

    {
        url: backofficeUrl('/printing-methods'),
        component: PrintTypes,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: PrintTypesPageSkeleton
    },
    { url: backofficeUrl('/printing-method/:id'), component: PrintTypePage, isSubscriptionRequested: true, skeleton: PrintTypePageSkeleton },
    { url: backofficeUrl('/printing-method/'), component: PrintTypePage, isSubscriptionRequested: true, skeleton: PrintTypePageSkeleton },
    {
        url: backofficeUrl('/printing-method-embedded/:id'),
        component: PrintTypePage,
        isMenuHidden: true,
        isHeaderHidden: true,
        isSubscriptionRequested: true,
        skeleton: PrintTypePageSkeleton
    },

    {
        url: backofficeUrl('/tools/extra-options'),
        component: AdditionalAttributes,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AdditionalAttributesPageSkeleton
    },
    {
        url: backofficeUrl('/tools/extra-option/:id'),
        component: AdditionalAttributePage,
        isSubscriptionRequested: true,
        skeleton: AdditionalAttributePageSkeleton
    },
    {
        url: backofficeUrl('/tools/extra-option/'),
        component: AdditionalAttributePage,
        isSubscriptionRequested: true,
        skeleton: AdditionalAttributePageSkeleton
    },

    { url: backofficeUrl('/order/:id'), component: OrderPage, isSubscriptionRequested: true, skeleton: OrderPageSkeleton },
    { url: backofficeUrl('/order/'), component: OrderPage, isSubscriptionRequested: true, skeleton: OrderPageSkeleton },
    // @ts-ignore
    { url: backofficeUrl('/order/code'), component: ShopifyOrderDetailContent, isSubscriptionRequested: true, skeleton: OrderPageSkeleton },
    {
        url: backofficeUrl('/settings/orders'),
        component: OrdersSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: OrdersSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/orders/'),
        component: Orders,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: OrdersPageSkeleton
    },
    { url: backofficeUrl('/marketplace-order/:id'), component: MarketplaceOrderPage, isSubscriptionRequested: true, skeleton: MarketplaceOrderPageSkeleton },
    { url: backofficeUrl('/marketplace-order/'), component: MarketplaceOrderPage, isSubscriptionRequested: true, skeleton: MarketplaceOrderPageSkeleton },

    {
        url: backofficeUrl('/proofs/:proofId/versions/:versionId'),
        component: ProofDetailsPage,
        isSubscriptionRequested: true,
        skeleton: ProofDetailsPageSkeleton
    },
    {
        url: backofficeUrl('/proofs/:proofId'),
        component: ProofDetailsPage,
        isSubscriptionRequested: true,
        skeleton: ProofDetailsPageSkeleton
    },
    {
        url: backofficeUrl('/proofs'),
        component: ProofListPage,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProofListPageSkeleton
    },

    { url: backofficeUrl('/orders/place/'), component: OfflineOrder, isSubscriptionRequested: true, skeleton: OfflineOrderPageSkeleton },

    {
        url: backofficeUrl('/order/design/edit/:designId'),
        component: OrderDesignEditor,
        isSubscriptionRequested: true,
        skeleton: OrderDesignEditorPageSkeleton
    },
    {
        url: backofficeUrl('/order/design/edit/'),
        component: OrderDesignEditor,
        isSubscriptionRequested: true,
        skeleton: OrderDesignEditorPageSkeleton
    },

    { url: backofficeUrl('/marketplace-orders/:id'), component: MarketplaceOrder, isSubscriptionRequested: true, skeleton: MarketplaceOrderPageSkeleton },

    {
        url: backofficeUrl('/tools/bulk-variation-form/products'),
        component: BulkProductsList,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: BulkProductsListPageSkeleton
    },
    {
        url: backofficeUrl('/tools/bulk-variation-form/:modelId'),
        component: BulkVariationPage,
        isSubscriptionRequested: true,
        skeleton: BulkVariationPageSkeleton
    },

    {
        url: backofficeUrl('/seller/checkoutforplan/:planIdForNewCustomer'),
        component: UserCheckout,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        skeleton: UserCheckoutPageSkeleton
    },
    { url: backofficeUrl('/seller/checkoutforplan/'), component: UserCheckout, isSubscriptionRequested: false, skeleton: UserCheckoutPageSkeleton },

    { url: backofficeUrl('/user/:tab?'), component: UserPage, isSubscriptionRequested: true, refreshCredits: true, skeleton: UserPageSkeleton },
    { url: backofficeUrl('/seller/overviewsubscription'), component: UserPage, isSubscriptionRequested: false, skeleton: UserPageSkeleton },

    {
        url: '/:culture/support',
        component: Support,
        forceTools: true,
        isMenuHidden: true,
        isGuestAllowed: true,
        isSubscriptionRequested: false,
        skeleton: SupportPageSkeleton
    },

    { url: backofficeUrl('/seller/billings'), component: InvoicesPage, isSubscriptionRequested: false, skeleton: InvoicesPageSkeleton },
    //{ url: backofficeUrl('/seller/billings/details/:id'), component: Invoice },

    {
        url: backofficeUrl('/seller/upgradetrialsubscription'),
        component: UserCheckout,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        skeleton: UserCheckoutPageSkeleton
    },

    {
        url: backofficeUrl('/settings/shopifyNeedUpdateScope'),
        component: ShopifyNeedUpdateScope,
        isSubscriptionRequested: true,
        skeleton: SettingsTablePageSkeleton
    },
    {
        url: backofficeUrl('/settings/integration-settings/:platform'),
        component: PlatformIntegrationSettings,
        isSubscriptionRequested: true,
        skeleton: PlatformIntegrationSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/integration-settings'),
        component: PlatformIntegrationSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: PlatformIntegrationSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/general'),
        component: GeneralSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: GeneralSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/general-configurator'),
        component: GeneralSettingsConfigurator,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: GeneralSettingsConfiguratorPageSkeleton
    },
    {
        url: backofficeUrl('/settings/additional-properties'),
        component: ExtensionFieldsSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ExtensionFieldsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/additional-properties/:id'),
        component: ExtensionFieldPage,
        isSubscriptionRequested: true,
        skeleton: ExtensionFieldPageSkeleton
    },
    { url: backofficeUrl('/settings/additional-property'), component: ExtensionFieldPage, isSubscriptionRequested: true, skeleton: ExtensionFieldPageSkeleton },
    {
        url: backofficeUrl('/settings/pdf-preview'),
        component: PdfPreviewSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: PdfPreviewSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/pdf-summary'),
        component: PdfSummarySettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SettingsFormPageSkeleton
    },
    {
        url: backofficeUrl('/settings/proof-workflows/:workflowDefinitionId'),
        component: ProofWorkflowDefinitionsPage,
        isSubscriptionRequested: true,
        skeleton: ProofWorkflowDefinitionsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/proof-workflows'),
        component: ProofWorkflowDefinitionsPage,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProofWorkflowDefinitionsPageSkeleton
    },

    {
        url: backofficeUrl('/mini-sites/:siteId/collection/new'),
        component: StandaloneSiteCollectionDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteCollectionPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:siteId/collection/:collectionId'),
        component: StandaloneSiteCollectionDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteCollectionPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:siteId/theme/:themeId/settings'),
        component: ThemeSettingsEditor,
        isMenuHidden: true,
        isHeaderHidden: true,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteThemeSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:id/settings'),
        component: StandaloneSiteDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteDetailPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:id/collections'),
        component: StandaloneSiteDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteDetailPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:id/themes'),
        component: StandaloneSiteDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteDetailPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:id/general'),
        component: StandaloneSiteDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteDetailPageSkeleton
    },
    {
        url: backofficeUrl('/mini-sites/:id'),
        component: StandaloneSiteDetail,
        isSubscriptionRequested: true,
        skeleton: StandaloneSiteDetailPageSkeleton
    },

    {
        url: backofficeUrl('/settings/color-palette-settings'),
        component: ColorPaletteSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ColorPaletteSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/color-palette-settings/palette/'),
        component: PaletteColorsPage, // Parent component that manages both views
        isSubscriptionRequested: true,
        skeleton: PaletteColorsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/color-palette-settings/palette/:id'),
        component: PaletteColorsPage,
        isSubscriptionRequested: true,
        skeleton: PaletteColorsPageSkeleton
    },

    {
        url: backofficeUrl('/settings/color-palette-settings/palette/'),
        component: PantoneLibraryPage, // Parent component that manages both views
        isSubscriptionRequested: true,
        skeleton: PantoneLibraryPageSkeleton
    },
    {
        url: backofficeUrl('/settings/color-palette-settings/palette/:id'),
        component: PantoneLibraryPage,
        isSubscriptionRequested: true,
        skeleton: PantoneLibraryPageSkeleton
    },

    { url: backofficeUrl('/tools/shapes/:subpage'), component: Shapes, isSubscriptionRequested: true, skeleton: ShapesPageSkeleton },
    { url: backofficeUrl('/tools/shapes/'), component: Shapes, isSubscriptionRequested: true, refreshCredits: true, skeleton: ShapesPageSkeleton },

    { url: backofficeUrl('/tools/image-gallery/:subpage'), component: Images, isSubscriptionRequested: true, skeleton: ImagesPageSkeleton },
    {
        url: backofficeUrl('/tools/image-gallery'),
        component: Images,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ImagesPageSkeleton
    },

    {
        url: backofficeUrl('/tools/template-product-selection'),
        component: ProductTemplates,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProductTemplatesPageSkeleton
    },
    {
        url: backofficeUrl('/tools/template-product-selection/templates/:productId'),
        component: ProductItemTemplates,
        isSubscriptionRequested: true,
        skeleton: ProductItemTemplatesPageSkeleton
    },
    { url: backofficeUrl('/tools/template-product-selection/standalone'), component: StandaloneTemplateEditor, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/template-product-selection/standalone/:templateId'), component: StandaloneTemplateEditor, isSubscriptionRequested: true },
    {
        url: backofficeUrl('/tools/template-product-selection/tasks/:taskId'),
        component: TemplateTaskDetail,
        isSubscriptionRequested: true,
        skeleton: TemplateTaskDetailPageSkeleton
    },

    {
        url: backofficeUrl('/settings/customizer-theme-items'),
        component: CustomizerThemeItems,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SettingsTablePageSkeleton
    },
    {
        url: backofficeUrl('/settings/customizer-theme-item/:category'),
        component: CustomizerThemeItemPage,
        isSubscriptionRequested: true,
        skeleton: SettingsFormPageSkeleton
    },

    {
        url: backofficeUrl('/settings/messages-and-alerts/'),
        component: SettingsMessages,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SettingsTablePageSkeleton
    },
    {
        url: backofficeUrl('/settings/customizerMessageByEvent/:eventId/:messageId'),
        component: CustomizerMessageByEvent,
        isSubscriptionRequested: true,
        skeleton: SettingsFormPageSkeleton
    },

    {
        url: backofficeUrl('/settings/translations'),
        component: Translations,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: TranslationsPageSkeleton
    },

    {
        url: backofficeUrl('/integration/provider-configuration-page'),
        component: ProviderConfiguration,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProviderConfigurationPageSkeleton
    },
    {
        url: backofficeUrl('/integration/provider-configuration-page/printful'),
        component: PrintfulProviderPage,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProviderDetailPageSkeleton
    },
    {
        url: backofficeUrl('/integration/provider-configuration-page/customcat'),
        component: CustomCatProviderPage,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProviderDetailPageSkeleton
    },
    {
        url: backofficeUrl('/integration/provider-configuration-page/printeers'),
        component: PrinteersProviderPage,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProviderDetailPageSkeleton
    },
    {
        url: backofficeUrl('/integration/provider-configuration-page/:subpage'),
        component: ProviderConfiguration,
        isSubscriptionRequested: true,
        skeleton: ProviderConfigurationPageSkeleton
    },
    {
        url: backofficeUrl('/integration/webhooks'),
        component: WebHooksSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SettingsTablePageSkeleton
    },

    {
        url: backofficeUrl('/landings/customizer'),
        component: CustomizerLanding,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: LandingPageSkeleton
    },
    {
        url: backofficeUrl('/landings/configurator'),
        component: ConfiguratorLanding,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: LandingPageSkeleton
    },
    {
        url: backofficeUrl('/landings/viewer'),
        component: ViewerLanding,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: LandingPageSkeleton
    },

    { url: backofficeUrl('/ai-creative-tools'), component: AI, isSubscriptionRequested: true, refreshCredits: true, skeleton: ToolsPageSkeleton },
    ...MENU_CATEGORY_ROUTE_KEYS.map((categoryKey) => ({
        url: backofficeUrl(`/${categoryKey}`),
        component: MenuCategoryPage,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ToolsPageSkeleton
    })),
    {
        url: backofficeUrl('/sales-channels/switch-tasks/:taskId'),
        component: SalesChannelSwitchTaskDetail,
        isSubscriptionRequested: true,
        skeleton: SalesChannelSwitchTaskDetailPageSkeleton
    },
    {
        url: backofficeUrl('/sales-channels/switch-tasks'),
        component: SalesChannelSwitchTasks,
        isSubscriptionRequested: true,
        skeleton: SalesChannelSwitchTasksPageSkeleton
    },
    {
        url: backofficeUrl('/sales-channels'),
        component: SalesChannels,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SalesChannelsPageSkeleton
    },
    {
        url: backofficeUrl('/proofing-hub'),
        component: ProofingHub,
        isSubscriptionRequested: true,
        skeleton: ProofingHubRouteSkeleton
    },

    {
        url: backofficeUrl('/tools/fill-background'),
        component: AreaBackgroundRulesOrImages,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: FillBackgroundPageSkeleton
    },
    {
        url: backofficeUrl('/tools/fill-background/rules'),
        component: AreaBackgroundRulesRedirect,
        isSubscriptionRequested: true
    },
    {
        url: backofficeUrl('/tools/fill-background/rule/:id?'),
        component: AreaBackgroundRule,
        isSubscriptionRequested: true,
        skeleton: FillBackgroundRulePageSkeleton
    },

    { url: backofficeUrl('/tools/fonts'), component: Fonts, isSubscriptionRequested: true, refreshCredits: true, skeleton: FontsPageSkeleton },

    {
        url: backofficeUrl('/tools/profanity-filter-menu'),
        component: ProfanityFilterMenu,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ProfanityFilterMenuPageSkeleton
    },
    {
        url: backofficeUrl('/tools/profanity-filter-and-image-moderator'),
        component: ProfanityFilterRules,
        isSubscriptionRequested: true,
        skeleton: ProfanityFilterRulesPageSkeleton
    },
    {
        url: backofficeUrl('/tools/profanity-filter-rule'),
        component: ProfanityFilterRule,
        isSubscriptionRequested: true,
        skeleton: ProfanityFilterRulePageSkeleton
    },
    {
        url: backofficeUrl('/tools/profanity-filter-analytics'),
        component: PorfanityFilterAnalytics,
        isSubscriptionRequested: true,
        skeleton: ProfanityFilterAnalyticsPageSkeleton
    },

    { url: backofficeUrl('/tools/moq'), component: MoqRule, isSubscriptionRequested: true, refreshCredits: true, skeleton: MoqPageSkeleton },
    { url: backofficeUrl('/tools/moq-rule/:id?'), component: MoqRule, isSubscriptionRequested: true, skeleton: MoqRulePageSkeleton },

    {
        url: backofficeUrl('/tools/color-system'),
        component: ColorSystem,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: ColorSystemPageSkeleton
    },
    {
        url: backofficeUrl('/tools/color-system/palette/:id?'),
        component: ColorSystemPage,
        isSubscriptionRequested: true,
        skeleton: ColorSystemPalettePageSkeleton
    },

    {
        url: backofficeUrl('/tools/collage-layouts'),
        component: CollageLayout,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: CollageLayoutPageSkeleton
    },
    { url: backofficeUrl('/tools/collage-layouts/:tab'), component: CollageLayout, isSubscriptionRequested: true, skeleton: CollageLayoutPageSkeleton },
    { url: backofficeUrl('/tools/collage-layouts/rule/:id?'), component: GridRule, isSubscriptionRequested: true, skeleton: CollageLayoutRulePageSkeleton },

    { url: backofficeUrl('/tools/get-a-quote'), component: GetAQuote, isSubscriptionRequested: true, refreshCredits: true, skeleton: GetAQuotePageSkeleton },
    { url: backofficeUrl('/tools/get-a-quote/:tab'), component: GetAQuote, isSubscriptionRequested: true, skeleton: GetAQuotePageSkeleton },
    { url: backofficeUrl('/tools/get-a-quote/quote-rule/:id?'), component: QuoteRule, isSubscriptionRequested: true, skeleton: QuoteRulePageSkeleton },
    { url: backofficeUrl('/tools/get-a-quote/quote/:id?'), component: Quote, isSubscriptionRequested: true, skeleton: QuotePageSkeleton },

    { url: backofficeUrl('/report-views-try-on'), component: ReportViewsTryOn, isSubscriptionRequested: true, skeleton: ReportViewsTryOnPageSkeleton },
    {
        url: backofficeUrl('/tools/design-to-template/:designId/:page'),
        component: DesignToTemplate,
        isSubscriptionRequested: true,
        skeleton: DesignToTemplatePageSkeleton
    },

    {
        url: backofficeUrl('/tools/advanced-print-file/products'),
        component: PlacementProduct,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AdvancedPrintFileProductsPageSkeleton
    },
    { url: backofficeUrl('/tools/advanced-print-file/:modelId'), component: Placements, isSubscriptionRequested: true, skeleton: PlacementPageSkeleton },
    // @ts-ignore
    {
        url: backofficeUrl('/tools/placement-product/:modelId/:placementId?'),
        component: Placement,
        isSubscriptionRequested: true,
        skeleton: PlacementProductPageSkeleton
    },

    {
        url: backofficeUrl('/tools/connector/:connectorKey/connector-rules'),
        component: ConnectorRules,
        isSubscriptionRequested: true,
        skeleton: ConnectorRulesPageSkeleton
    },
    {
        url: backofficeUrl('/tools/connector/:connectorKey/connector-rule/:ruleId?'),
        component: ConnectorRule,
        isSubscriptionRequested: true,
        skeleton: ConnectorRulePageSkeleton
    },

    {
        url: backofficeUrl('/tools/CSVImporter'),
        component: CsvImporter,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: CsvImporterPageSkeleton
    },

    {
        url: backofficeUrl('/tools/bulk-import'),
        component: BulkImportLanding,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: BulkImportPageSkeleton
    },
    {
        url: backofficeUrl('/tools/bulk-import/history'),
        component: BulkImportHistory,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: BulkImportHistoryPageSkeleton
    },
    {
        url: backofficeUrl('/tools/bulk-import/wizard'),
        component: BulkImportWizard,
        isSubscriptionRequested: true,
        skeleton: BulkImportWizardPageSkeleton
    },
    {
        url: backofficeUrl('/tools/bulk-import/setup'),
        component: BulkImportSetup,
        isSubscriptionRequested: true,
        skeleton: BulkImportSetupPageSkeleton
    },
    {
        url: backofficeUrl('/tools/bulk-import/export/wizard'),
        component: BulkImportExportWizard,
        isSubscriptionRequested: true,
        skeleton: BulkImportExportWizardPageSkeleton
    },
    {
        url: backofficeUrl('/tools/bulk-import/task/:taskId'),
        component: BulkImportTaskDetail,
        isSubscriptionRequested: true,
        skeleton: BulkImportTaskDetailPageSkeleton
    },

    {
        url: backofficeUrl('/ai-creative-tools/usage-history'),
        component: AIUsageHistory,
        isSubscriptionRequested: true,
        skeleton: AIUsageHistoryPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/image-generation-editing'),
        component: AIImageGeneration,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AIImageGenerationPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/design-generation'),
        component: DesignWithAi,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: DesignWithAiPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/studio'),
        component: AiStudio,
        noGutters: true,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AiStudioPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/studio/library'),
        component: AiStudio,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AiStudioPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/studio/custom-apps'),
        component: AiStudio,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AiStudioPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/custom-apps'),
        component: AICreativeToolsCustomApps,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AICreativeToolsCustomAppsPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/lifestyle-scenes-rules'),
        component: AIProductStagingRules,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AIProductStagingRulesPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/lifestyle-scenes-builder/:id?'),
        component: AIProductStagingRule,
        isSubscriptionRequested: true,
        skeleton: AIProductStagingRulePageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/ai-tryon-rules'),
        component: AIVirtualModelRules,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: AIVirtualModelRulesPageSkeleton
    },
    {
        url: backofficeUrl('/ai-creative-tools/ai-tryon-builder/:id?'),
        component: AIVirtualModelRule,
        isSubscriptionRequested: true,
        skeleton: AIVirtualModelRulePageSkeleton
    },

    { url: backofficeUrl('/dam'), component: DamLegacyRedirect, isSubscriptionRequested: true, skeleton: DamPageSkeleton },
    { url: backofficeUrl('/dam/projects'), component: DamProjects, isSubscriptionRequested: true, skeleton: DamProjectsListingPageSkeleton },
    { url: backofficeUrl('/dam/projects/:id'), component: DamProjectDetail, isSubscriptionRequested: true, skeleton: DamProjectsDetailPageSkeleton },
    { url: backofficeUrl('/dam/asset-library'), component: DamAssetLibrary, isSubscriptionRequested: true, skeleton: DamAssetLibraryListingPageSkeleton },
    {
        url: backofficeUrl('/dam/asset-library/:id'),
        component: DamAssetLibraryDetail,
        isSubscriptionRequested: true,
        skeleton: DamAssetLibraryDetailPageSkeleton
    },
    { url: backofficeUrl('/dam/analytics'), component: DamAnalytics, isSubscriptionRequested: true, skeleton: DamAnalyticsPageSkeleton },
    { url: backofficeUrl('/dam/optimize/:id'), component: DamOptimize, isSubscriptionRequested: true, skeleton: DamOptimizePageSkeleton },
    {
        url: backofficeUrl('/damRelayer'),
        component: DamRelayer,
        isHeaderHidden: true,
        isMenuHidden: true,
        isSubscriptionRequested: true,
        skeleton: DamPageSkeleton
    },

    {
        url: backofficeUrl('/dashboardAnalytics'),
        component: DashboardAnalytics,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: DashboardAnalyticsPageSkeleton
    },

    {
        url: backofficeUrl('/virtual-try-on/:subpage?'),
        component: VirtualTryOn,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: VirtualTryOnPageSkeleton
    },

    {
        url: backofficeUrl('/settings/theme'),
        component: UserInterfaceSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: UserInterfaceSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/UserInterface/:sellerUserInterfaceId'),
        component: UserInterfaceSettingsEditor,
        isMenuHidden: true,
        isHeaderHidden: true,
        isSubscriptionRequested: true,
        skeleton: SettingsFormPageSkeleton
    },
    {
        url: backofficeUrl('/settings/UserInterface/new'),
        component: UserInterfaceNew,
        isMenuHidden: true,
        isHeaderHidden: true,
        isSubscriptionRequested: true,
        skeleton: SettingsFormPageSkeleton
    },
    {
        url: backofficeUrl('/settings/UserInterface'),
        component: UserInterfaceSettings,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: UserInterfaceSettingsPageSkeleton
    },
    {
        url: backofficeUrl('/settings/Theme-3D-Configurator'),
        component: UserInterfaceSettingsConfigurator,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SettingsFormPageSkeleton
    },

    {
        url: backofficeUrl('/settings/Seller/PantoneColors'),
        component: PantoneColors,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: SellerPantoneColorsPageSkeleton
    },

    {
        url: backofficeUrl('/tools/background-recolor/rule/:id?'),
        component: BackgroundColorRule,
        isSubscriptionRequested: true,
        skeleton: BackgroundColorRulePageSkeleton
    },
    {
        url: backofficeUrl('/tools/background-recolor'),
        component: BackgroundColorRules,
        isSubscriptionRequested: true,
        refreshCredits: true,
        skeleton: BackgroundColorRulesPageSkeleton
    },
    // old URL redirect to /tools/background-recolor
    {
        url: backofficeUrl('/Tools/BackgroundRecolorRules'),
        component: BackgroundRecolorRedirect,
        isSubscriptionRequested: true
    },

    /*Guest allowed routes*/
    {
        url: '/:culture/pricing',
        component: ChoosePlan,
        forceTools: true,
        isMenuHidden: true,
        isGuestAllowed: true,
        isSubscriptionRequested: false,
        skeleton: ChoosePlanPageSkeleton
    },
    {
        url: '/:culture/pricing/:ecommercename',
        component: ChoosePlan,
        isGuestAllowed: true,
        isSubscriptionRequested: false,
        skeleton: ChoosePlanPageSkeleton
    },

    {
        url: '/:culture/pricingV2',
        component: ChoosePlanV2,
        forceTools: true,
        isMenuHidden: true,
        isGuestAllowed: true,
        isSubscriptionRequested: false,
        skeleton: ChoosePlanPageSkeleton
    },
    {
        url: '/:culture/pricingV2/:ecommercename',
        component: ChoosePlanV2,
        isGuestAllowed: true,
        isSubscriptionRequested: false,
        skeleton: ChoosePlanPageSkeleton
    },

    { url: backofficeUrl('/seller/redirectForUpgradePlanForShopify'), component: RedirectForUpgradePlanForShopify },

    { url: '/:culture/PartnerProgramContact', component: RedirectPartner, isGuestAllowed: true, isSubscriptionRequested: false },

    /* Checker pages */
    {
        url: backofficeUrl('/user_sync_checker'),
        component: UserSyncChecker,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        isGuestAllowed: true
    },
    {
        url: backofficeUrl('/SubscriptionChecker'),
        component: SubscriptionChecker,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        isGuestAllowed: true
    },
    {
        url: backofficeUrl('/Subscription/CheckForActivation'),
        component: SubscriptionCheckForActivation,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        isGuestAllowed: true
    },
    {
        url: backofficeUrl('/Subscription/CheckForExisting'),
        component: SubscriptionCheckForExisting,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        isGuestAllowed: true
    },
    {
        url: backofficeUrl('/Subscription/CheckForCancelling'),
        component: SubscriptionCheckForCancelling,
        forceTools: true,
        isMenuHidden: true,
        isSubscriptionRequested: false,
        isGuestAllowed: true
    },
    {
        url: backofficeUrl('/Subscription/TrialExtension'),
        component: SubscriptionRequestTrialExtension,
        isHeaderHidden: true,
        isMenuHidden: true,
        isSubscriptionRequested: false
    },
    { url: backofficeUrl('/cli-login'), component: CliLogin, isHeaderHidden: true, isMenuHidden: true, isSubscriptionRequested: false },

    { url: backofficeUrl('/QuotesNoActivated'), component: EmptyPage, isSubscriptionRequested: true },
    { url: backofficeUrl('/integration/Printful/Auth'), component: PrintfulIntegration, forceTools: false, isMenuHidden: true, isSubscriptionRequested: true },

    /* Legacy redirects — routes renamed or removed in the May 2026 release */

    // 3D Preview: /preview3d/* → /3Dpreview-and-AR/*
    { url: backofficeUrl('/preview3d/products'), component: Preview3DProductsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/preview3d/cameras'), component: Preview3DCamerasRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/preview3d/:subpage?'), component: Preview3DRedirect, isSubscriptionRequested: true },

    // Test mode: /preview/test/* → /test-mode/*
    { url: backofficeUrl('/preview/test/:productId'), component: TestModeRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/preview/test/'), component: TestModeRedirect, isSubscriptionRequested: true },

    // Draft designs: /draftdesigns → /draft-designs, /draftconfigurations → /draft-configurations
    { url: backofficeUrl('/draftdesigns'), component: DraftDesignsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/draftconfigurations'), component: DraftConfigurationsRedirect, isSubscriptionRequested: true },

    // AI tools: /ai/* → /ai-creative-tools/*
    { url: backofficeUrl('/ai'), component: AIRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/image-generation-editing'), component: AIImageGenerationRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/design-generation'), component: AIDesignGenerationRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/studio'), component: AIStudioLegacyRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/product-staging-rules'), component: AIProductStagingRulesLegacyRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/product-staging-rule/:id?'), component: AIProductStagingRuleLegacyRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/virtual-model-rules'), component: AIVirtualModelRulesLegacyRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai/virtual-model-rule/:id?'), component: AIVirtualModelRuleLegacyRedirect, isSubscriptionRequested: true },

    // AI creative tools: intermediate rename /product-staging-* and /virtual-model-* → lifestyle-scenes / ai-tryon
    { url: backofficeUrl('/ai-creative-tools/product-staging-rules'), component: AIProductStagingRulesRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai-creative-tools/product-staging-rule/:id?'), component: AIProductStagingRuleRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai-creative-tools/virtual-model-rules'), component: AIVirtualModelRulesRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/ai-creative-tools/virtual-model-rule/:id?'), component: AIVirtualModelRuleRedirect, isSubscriptionRequested: true },

    // Pricing: /pricing-advanced/* → /pricing-rule/*, /pricing-rules/* → /pricing-rule/*, /pricings-advanced → /pricings-rules
    { url: backofficeUrl('/pricing-advanced/:subpage?'), component: PricingAdvancedRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/pricing-advanced-embedded/:subpage?'), component: PricingAdvancedEmbeddedRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/pricing-rules/:subpage?'), component: PricingRulesRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/pricing-rules-embedded/:subpage?'), component: PricingRulesEmbeddedRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/pricings-advanced'), component: PricingsAdvancedRedirect, isSubscriptionRequested: true },

    // Image gallery: /tools/images/* → /tools/image-gallery/*
    { url: backofficeUrl('/tools/images/'), component: ImagesRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/images/:subpage'), component: ImagesSubpageRedirect, isSubscriptionRequested: true },

    // Profanity filter: /tools/profanity-filter-rules → /tools/profanity-filter-and-image-moderator
    { url: backofficeUrl('/tools/profanity-filter-rules'), component: ProfanityFilterRulesRedirect, isSubscriptionRequested: true },

    // MOQ: /tools/moq-menu and /tools/moq-rules → /tools/moq
    { url: backofficeUrl('/tools/moq-menu'), component: MoqMenuRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/moq-rules'), component: MoqRulesRedirect, isSubscriptionRequested: true },

    // Collage layout: /tools/collage-layout/* → /tools/collage-layouts/*
    // Note: /grid-rules list page was also removed — redirect to main collage page
    { url: backofficeUrl('/tools/collage-layout'), component: CollageLayoutRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/collage-layout/grid-rules'), component: CollageLayoutGridRulesRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/collage-layout/grid-rule/:id?'), component: CollageLayoutGridRuleRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/collage-layout/:tab'), component: CollageLayoutTabRedirect, isSubscriptionRequested: true },

    // Bulk variation form: old /settings/* paths and /tools/bulk-variation/* paths
    { url: backofficeUrl('/settings/bulk-variation-product-list'), component: BulkVariationSettingsListRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/settings/bulk-variation/:modelId'), component: BulkVariationSettingsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/bulk-variation-product-list'), component: BulkVariationProductListRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/bulk-variation/:modelId'), component: BulkVariationRedirect, isSubscriptionRequested: true },

    // Template tasks: /tools/template-tasks/* → /tools/template-product-selection/*
    { url: backofficeUrl('/tools/template-tasks'), component: TemplateTasksRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/template-tasks/:taskId'), component: TemplateTaskDetailRedirect, isSubscriptionRequested: true },

    // Advanced print file
    { url: backofficeUrl('/tools/placement-product-selection'), component: PlacementProductSelectionRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/placements/:modelId'), component: PlacementsRedirect, isSubscriptionRequested: true },

    // Fill background: /tools/area-background/* → /tools/fill-background/*
    { url: backofficeUrl('/tools/area-background'), component: AreaBackgroundRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/area-background/rules'), component: AreaBackgroundRulesRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/tools/area-background/rule/:id?'), component: AreaBackgroundRuleRedirect, isSubscriptionRequested: true },

    // Translations: /settings/translations-container/:page → /settings/translations
    { url: backofficeUrl('/settings/translations-container/:page'), component: TranslationsContainerRedirect, isSubscriptionRequested: true },

    // Customizer messages: /settings/customizer-messages/ → /settings/messages-and-alerts/
    { url: backofficeUrl('/settings/customizer-messages/'), component: CustomizerMessagesRedirect, isSubscriptionRequested: true },

    // Integration settings: /settings/sales-channel-integration/* → /settings/integration-settings/*
    { url: backofficeUrl('/settings/sales-channel-integration'), component: SalesChannelIntegrationRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/settings/sales-channel-integration/:platform'), component: SalesChannelIntegrationPlatformRedirect, isSubscriptionRequested: true },

    // Integrations page (removed) → integration settings
    { url: backofficeUrl('/integrations'), component: IntegrationsRedirect, isSubscriptionRequested: true },

    // Legacy platform settings pages (removed) → unified integration settings
    { url: backofficeUrl('/settings/bigcommerce'), component: LegacyPlatformSettingsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/settings/shopify'), component: LegacyPlatformSettingsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/settings/shopify/:subpage'), component: LegacyPlatformSettingsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/settings/wix'), component: LegacyPlatformSettingsRedirect, isSubscriptionRequested: true },
    { url: backofficeUrl('/settings/marketplace'), component: LegacyPlatformSettingsRedirect, isSubscriptionRequested: true }
];

export default routes;
